"use client";
import { Box, CircularProgress, IconButton, Stack } from "@mui/material";
import { WebShopIcon } from "@/src/components/WebShopIcon";
import { Button } from "@/src/components/Button";
import { ApiCallsAutoSearchErrorModalData } from "../../types";
import { maskFunctions } from "@/src/shared/utils/mask";

export const ApiCallsAutoSearchForbiddenModal = ({
  onClose,
  plateNumber,
}: Pick<ApiCallsAutoSearchErrorModalData, "plateNumber"> & {
  onClose: () => void;
}) => {
  return (
    <Box className="flex w-full max-w-[524px] flex-col gap-6 rounded-xl bg-white p-6 shadow-xl center-modal max-md:animate-up-modal max-md:bottom-modal">
      <Stack className="flex flex-col gap-2 rounded-lg text-base text-dark-gray">
        <Box className={"flex flex-col items-center justify-center gap-3"}>
          <Box
            className={
              "flex aspect-square w-[68px] items-center justify-center rounded-full bg-[#FF00000D]"
            }
          >
            <WebShopIcon name="triangle-alert" width={32} fill="#ff0000" />
          </Box>
          <Box className={"text-lg font-semibold text-dark-gray"}>
            Транспортний засіб не знайдено!
          </Box>
          <Box className={"text-center text-base text-dark-gray"}>
            За даним реєстраційним номером{" "}
            <span className="font-semibold">
              {maskFunctions.numberPlate(plateNumber || "")}
            </span>{" "}
            інформації не знайдено, будь ласка, змініть номер транспортного
            засобу.
          </Box>
        </Box>
      </Stack>
      <Stack className="flex flex-row flex-nowrap gap-3 [&>*]:flex-1">
        <Button variant={"outlined"} onClick={onClose}>
          Змінити номер
        </Button>
      </Stack>
    </Box>
  );
};
